/**
 * @desc 处理未付款亚马逊单据
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.omsFlow.backdoor.processUnpaidOrder.Params, options?: any) {
  return updateResponse(
    http(URL + `/backdoor/processUnpaidOrder`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
